import HomePage from '../components/pages/home/HomePage';
import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import HowItWorksPage from '../components/pages/howitworks/HowItWorksPage';
import AccountPage from '../components/pages/account/AccountPage';
import ContactRequestPage from '../components/pages/contactrequest/ContactRequestPage';
import FaqPage from '../components/pages/faq/FaqPage';
import CashbackDirectoryPage from '../components/pages/directory/CashbackDirectoryPage';
import ReductionDirectoryPage from '../components/pages/directory/ReductionDirectoryPage';
import LegalNoticePage from '../components/pages/LegalNoticePage';
import MerchantCardPage from '../components/pages/merchantcard/MerchantCardPage';
import TermsPage from '../components/pages/terms/TermsPage';
import TermsOfSalesPage from '../components/pages/termsofsales/TermsOfSalesPage';
import UnsubscribePage from '../components/pages/unsubscribe/UnsubscribePage';
import InterstitielComponent from '../components/pages/interstitiel/InterstitielComponent';
import PasswordResetInitFormComponent from '../components/pages/resetpassword/PasswordResetInitFormComponent';
import PasswordResetCommitFormComponent from '../components/pages/resetpassword/PasswordResetCommitFormComponent';
import SponsorshipPage from '../components/pages/sponsorship/SponsorshipPage';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';
import { accountRoutes } from './account';
import { directoryRoutes } from './directory';
import { localizeRoutes } from '../utils/routeUtils';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: '/',
        exact: true,
        component: HomePage
    },
    {
        path: PATH.HOW_IT_WORK_PATH,
        exact: true,
        component: HowItWorksPage
    },
    {
        path: `${PATH.MERCHANTPAGE_PATH}:query`,
        component: MerchantCardPage
    },
    {
        path: PATH.CASHBACK_PATH,
        component: CashbackDirectoryPage
    },
    {
        path: PATH.REDUCTION_PATH,
        component: ReductionDirectoryPage
    },
    {
        path: PATH.ACCOUNT_PATH,
        component: AccountPage
    },
    {
        path: PATH.FAQ_PATH,
        exact: true,
        component: FaqPage
    },
    {
        path: PATH.LEGAL_NOTICE_PATH,
        exact: true,
        component: LegalNoticePage
    },
    {
        path: PATH.TERMS_OF_SALES,
        exact: true,
        component: TermsOfSalesPage
    },

    {
        path: PATH.TERMS_PATH,
        exact: true,
        component: TermsPage
    },
    {
        path: PATH.CONTACTREQUEST_PATH,
        exact: true,
        component: ContactRequestPage
    },
    {
        path: PATH.UNSUBSCRIBE_PATH,
        exact: true,
        component: UnsubscribePage
    },
    {
        path: `${PATH.INTERSTITIEL_CASHBACK_PATH}:partnerId/:clickSource/:username?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_REDUCTION_PATH}:partnerId/:clickSource/:couponId/:username?`,
        component: InterstitielComponent
    },
    {
        path: PATH.PASSWORD_RESET_PATH,
        exact: true,
        component: PasswordResetInitFormComponent
    },
    {
        path: `${PATH.PASSWORD_RESET_PATH}/:email/:token`,
        exact: true,
        component: PasswordResetCommitFormComponent
    },
    {
        path: `${PATH.SPONSORSHIP_PATH}`,
        exact: true,
        component: SponsorshipPage
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: PATH.PAGE_NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: NotFoundPage
    }
];

/**
 * First level routes + sub levels routes
 * Mainly used for breadcrumb
 */
const subRoutes = [...accountRoutes, ...directoryRoutes];

export const allRoutes = [...routes, ...subRoutes, ...localizeRoutes(LOCALES, subRoutes)];



// WEBPACK FOOTER //
// ./src/routes/index.js